module.exports = __webpack_public_path__ + "img/burger_onboard.9459d20b.svg";